import {Injectable, Injector} from '@angular/core';
import { AuthService } from '@mydocma/auth';
import {LoggerUserService} from '@mydocma/common/src/lib/logger';
import {map, Observable, of, take} from 'rxjs';

@Injectable()
export class MmLoggerUserService implements LoggerUserService {

  authService: AuthService;
  constructor(private injector: Injector) {
    console.log("MmLoggerUserService: ctor")
  }

  private getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService)
    }
    return this.authService;
  }

  getUserSerialization(): Observable<string> | string {
    const authService = this.getAuthService()
    if (!authService) {
      return of('anon')
    }

    return this.authService.user.pipe(
      map(u=> !u ? 'anon' : u?.name || u?.email ))
  }
}
